import { gql } from '@apollo/client';

export const studentFinishedPracticeSessionFragment = gql`
  fragment StudentFinishedPracticeSession on StudentFinishedPracticeSession {
    _id
    score
    createdAt
    finishedAt
    finished
    maxScore
    name

    exercises {
      id: _id
      text
      type
      code
      explanation
      media
      questions
    }
  }
`;
